import { useEffect } from "react";

// Calls `onDismiss` on Escape and, when `ref` is given, on pointer-down outside it
export default function useDismiss(active, onDismiss, ref) {
  useEffect(() => {
    if (!active) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onDismiss();
      }
    };
    const handlePointerDown = (event) => {
      if (ref?.current && !ref.current.contains(event.target)) {
        onDismiss();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("pointerdown", handlePointerDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("pointerdown", handlePointerDown);
    };
  }, [active, onDismiss, ref]);
}
